import withEntity from '@/entity/components/with-entity';

import AddressFieldset from './address-fieldset';

export default withEntity(AddressFieldset);
